<mat-card class="portal-page-heading mb-2">
  <mat-card-content>
    <div class="flex flex-row justify-start items-center gap-4">
      <mat-icon class="portal-heading-icon" aria-hidden="true" fontIcon="home_health"></mat-icon>
      <h1 class="portal-page-title">{{ assigned? 'Manage My Assignments' : 'Manage In Home Care Licenses'}}</h1>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col mt-6" *ngIf="license.id === 0" [@slideRight]>
  <form [formGroup]="searchForm" *ngIf="!assigned" (ngSubmit)="searchLicenses()">
    <div class="license-search-controls">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput formControlName="searchTerm">
      </mat-form-field>

      <mat-form-field *ngIf="!renewal">
        <mat-label>Statuses</mat-label>
        <mat-select formControlName="statuses" multiple>
          <mat-option *ngFor="let status of sharedService.statuses" [value]="status">{{status}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox formControlName="includeArchived" labelPosition="before">
        <span>Include Archived</span>
      </mat-checkbox>

      <button type="button" mat-raised-button color="primary" (click)="searchLicenses()">Search</button>
    </div>
    <div *ngIf="!renewal" class="license-create-action">
      <button type="button" mat-raised-button color="primary" (click)="createLicense()">Create License</button>
    </div>
  </form>

  <span class="text-xl font-semibold pb-4" *ngIf="assigned">My Assigned Licenses</span>

  <mat-table [dataSource]="licenseSource" matSort #licenseSort="matSort" aria-describedby="in home care licenses" class="mat-elevation-z8 portal-responsive-table">
    <ng-container matColumnDef="licenseId">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">License ID</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license">
        <span class="mobile-label">ID</span>
        <div class="license-id-details">
          <span>{{ license.licenseId }}</span>
          <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)" color="primary"
            matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="expirationDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Expiration Date</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Exp Dt</span>
        {{ license.expirationDate }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="entityName">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Agency Name</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Name</span>
        <div class="agency-name-details"><span class="font-semibold">{{ license.entityName }}</span><span *ngIf="license.agencyDBAName"><abbr title="Doing Business As">DBA</abbr>: {{ license.agencyDBAName }}</span></div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="parentCity">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">City</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">City</span>
        {{ license.agencyCity }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="statuses">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Status</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Status</span>
        <div class="flex flex-col">
          <span *ngFor="let status of license.statuses">{{ status.label }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="isSubunit">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Subunit</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Subunit</span>
        {{ license.isSubunit? 'Yes' : 'No' }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="agencyPhone">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Phone</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Phone</span>
        {{ license.agencyPhone | mask:"000-000-0000" }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="agencyEmail">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Email</mat-header-cell>
      <mat-cell tabindex="0" (click)="selectLicense(license)" *matCellDef="let license" (keydown.enter)="$event.target === $event.currentTarget && (selectLicense(license))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLicense(license))">
        <span class="mobile-label">Email</span>
        <span class="license-table-email">{{ license.agencyEmail }}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="assignedToName">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Assigned To</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license">
        <span class="mobile-label">Assigned</span>
        <mat-form-field style="margin-top: 0.25em; margin-bottom: -1em; height: 50pt;">
          <mat-select [(value)]="license.assignedToName" (selectionChange)="assignLicense($event, license.id)">
            <mat-option>-- None --</mat-option>
            <mat-option *ngFor="let staff of staff" [value]="staff.name">{{staff.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="licenseColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: licenseColumns" class=""
             [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="assigned? [20, 50, 100] : [50, 100, 20]" #licensePaginator="matPaginator" (page)="onPaginationChange()">
  </mat-paginator>
</div>

<div class="flex flex-col pt-4" *ngIf="license.id !== 0" [@slideRight]>
  <div class="grid grid-cols-6 gap-2 items-center pb-4 portal-toolbar">
    <div class="flex flex-row col-span-4 items-center gap-4 portal-actions">
      <div class="license-manage-title text-xl font-semibold"><span>Manage {{ license.entityName }}</span><span *ngIf="license.agencyDBAName"><abbr title="Doing Business As">DBA</abbr>: {{ license.agencyDBAName }}</span></div>
      <span class="text-lg">Id: {{license.id}}</span>
      <div class="flex flex-row justify-start items-center portal-actions">
        <span class="text-base" id="licenseId">{{license.licenseId}}</span>
        <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)" color="primary"
          matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <button type="button" mat-button color="primary" (click)="viewAuditLog()">Audit Log</button>

      <button *ngIf="approved" type="button" mat-button color="primary" (click)="openPDFDialog(license)">Print License</button>
    </div>

    <div class="gap-4 flex col-span-2 justify-self-end items-center portal-actions">
      <button *ngIf="editing" type="button" mat-button
              [color]="license.archived? 'primary' : 'warn'"
              (click)="archiveLicense(license, !license.archived)"
              [matTooltip]="license.archived? 'Un-Archive License' : 'Archive License'"
              matTooltipShowDelay="500" matTooltipHideDelay="200">
        {{ license.archived? 'Un-Archive' : 'Archive' }}
      </button>
      <button type="button" mat-raised-button [color]="editing? 'warn' : 'primary'" (click)="toggleEditing(!editing)"
              [matTooltip]="editing? 'Stop Editing' : 'Edit'" matTooltipShowDelay="500" matTooltipHideDelay="200">
        <mat-icon>{{ editing? 'edit_off' : 'edit' }}</mat-icon>
      </button>
      <button class="ml-auto" type="button" mat-raised-button color="primary" (click)="saveLicense()">Save License</button>
      <button type="button" mat-raised-button color="primary" (click)="closeLicense()">Close</button>
    </div>
  </div>

  <form [formGroup]="licenseForm">
    <!-- Agency Info -->
    <mat-card>
      <mat-card-content>
        <mat-card>
          <mat-card-content>
            <div class="flex flex-col md:flex-row gap-4 portal-section-grid">
              <div class="flex flex-col md:w-1/2 portal-agency-panel">

                <!-- Review View -->
                <div class="portal-agency-review" *ngIf="!editing">
                  <div class="portal-agency-group">
                    <div class="flex flex-col md:w-1/3" *ngIf="license.isSubunit">
                      <div class="flex flex-col">
                        <span class="font-semibold pb-2">Parent: {{license.parentAgency}}</span>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">License:</span>
                          <span>{{license.parentGuid}}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">City:</span>
                          <span>{{license.parentCity}}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-section-grid" *ngIf="addressesLoaded">
                          <span class="font-semibold md:w-1/4">Distance:</span>
                          <span *ngIf="license.calculatedDistance! > 0"
                            [ngClass]="license.calculatedDistance! >= 60 || approved? 'text-green-500' : 'text-red-600'">
                            {{ license.calculatedDistance }} Miles</span>
                          <span *ngIf="license.calculatedDistance === 0 && !hasPhysicalAddress()" class="text-red-600">Add Physical Address to Verify</span>

                          <div class="flex flex-col gap-2 w-2/3" *ngIf="license.calculatedDistance === 0 && hasPhysicalAddress()">
                            <span class="text-amber-600">Unknown Distance</span>
                            <mat-form-field>
                              <mat-label>Distance in Miles</mat-label>
                              <input matInput formControlName="calculatedDistance">
                            </mat-form-field>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="flex flex-col" [ngClass]="license.isSubunit? 'md:w-1/3' : 'md:w-1/2'">
                      <div class="flex flex-col">
                        <span class="font-semibold pb-2">Agency Info</span>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold">Classification:</span>
                          <span>{{license.classificationLevel}}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Name:</span>
                          <span>{{license.entityName}}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4"><abbr title="Doing Business As">DBA</abbr>:</span>
                          <span>{{license.agencyDBAName}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="flex flex-col" [ngClass]="license.isSubunit? 'md:w-1/3' : 'md:w-1/2'">
                      <div class="flex flex-col">
                        <span class="font-semibold pb-2">Agency Contact Info</span>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Phone:</span>
                          <span>{{ license.agencyPhone! | mask:"000-000-0000" }}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Email:</span>
                          <span class="break-after-20">{{license.agencyEmail}}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Fax:</span>
                          <span>{{license.agencyFax! | mask:"000-000-0000"}}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="portal-agency-group">
                    <div class="flex flex-col md:w-1/3">
                      <div class="flex flex-col">
                        <span class="font-semibold pb-2">Emergency Contact</span>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Name:</span>
                          <span>{{ license.emergencyContactName }}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Phone:</span>
                          <span>{{ license.emergencyContactPhone! | mask:"000-000-0000" }}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Email:</span>
                          <span class="break-after-20">{{ license.emergencyContactEmail }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="flex flex-col md:w-1/3">
                      <div class="flex flex-col">
                        <span class="font-semibold pb-2">Administrator Designee</span>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Name:</span>
                          <span>{{ license.adminDesigneeName }}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Title:</span>
                          <span>{{ license.adminDesigneeTitle }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="flex flex-col md:w-1/3">
                      <div class="flex flex-col">
                        <span class="font-semibold pb-2">Qualified Individual/Entity</span>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Name:</span>
                          <span>{{ license.qualifiedEntityName }}</span>
                        </div>

                        <div class="flex flex-row gap-4 portal-detail-row">
                          <span class="font-semibold md:w-1/4">Title:</span>
                          <span>{{ license.qualifiedEntityTitle }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="portal-agency-group">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <div class="flex flex-col" *ngIf="licenseForm.get('classificationLevel')?.value === 'Intermediate' ||
                                                        licenseForm.get('classificationLevel')?.value  === 'Comprehensive'">
                        <span class="font-semibold"><strong>Registered Nurse Name</strong></span>
                        <span>{{ license.registeredNurseName }}</span>
                      </div>
                    </div>

                    <div class="flex flex-col md:w-1/3">
                      <span class="font-semibold pb-2">Administrator</span>

                      <div class="flex flex-row gap-4 portal-detail-row">
                        <span class="font-semibold md:w-1/4">Signature:</span>
                        <span>{{ license.electronicSignature }}</span>
                      </div>

                      <div class="flex flex-row gap-4 portal-detail-row">
                        <span class="font-semibold md:w-1/4">Title:</span>
                        <span>{{ license.adminPrintTitle }}</span>
                      </div>

                      <div class="flex flex-row gap-4 portal-detail-row">
                        <span class="font-semibold md:w-1/4">Signed:</span>
                        <span>{{ license.signedDate | date: 'MM/dd/yyyy' }}</span>
                      </div>
                    </div>

                    <div class="flex flex-col">
                      <mat-checkbox class="-mt-3" formControlName="backgroundCheckCompleted" labelPosition="before">
                        <span class="font-semibold">BG Check Complete</span>
                      </mat-checkbox>
                      <mat-form-field>
                        <input placeholder="Background Check Date" formControlName="backgroundCheckDate" matInput [matDatepicker]="backgroundCheckDate"
                          [max]="sharedService.today" />
                        <mat-datepicker-toggle matSuffix [for]="backgroundCheckDate"></mat-datepicker-toggle>
                        <mat-datepicker #backgroundCheckDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                      </mat-form-field>
                    </div>

                  </div>
                </div>

                <!-- Edit View -->
                <div class="flex flex-col gap-2" *ngIf="editing">
                  <div class="flex flex-col md:flex-row md:gap-4 md:items-center portal-actions">
                    <span class="font-semibold">Classification Level</span>

                    <button type="button" *ngIf="approved" mat-button color="primary"
                      (click)="requestChange(0, sharedService.classification, sharedService.change)">
                      Change Classification</button>

                    <mat-checkbox class="ml-auto" formControlName="isSubunit" labelPosition="before">
                      <span class="text-lg">This application is for a subunit</span>
                    </mat-checkbox>
                  </div>

                  <mat-form-field appearance="fill" class="flex-col gap-2">
                    <input matInput formControlName="classificationLevel" style="display: none;">
                    <mat-radio-group aria-labelledby="classification level" formControlName="classificationLevel">
                      <mat-radio-button value="Limited">
                        <span class="font-semibold pr-4">Limited</span>
                      </mat-radio-button>
                      <mat-radio-button value="Basic">
                        <span class="font-semibold pr-4">Basic</span>
                      </mat-radio-button>
                      <mat-radio-button value="Intermediate">
                        <span class="font-semibold pr-4">Intermediate</span>
                      </mat-radio-button>
                      <mat-radio-button value="Comprehensive">
                        <span class="font-semibold pr-4">Comprehensive</span>
                      </mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="licenseForm.get('classificationLevel')?.invalid">
                      You must select a classification level
                    </mat-error>
                  </mat-form-field>

                  <div class="flex flex-col" *ngIf="licenseForm.get('isSubunit')?.value">
                    <div class="flex flex-col md:flex-row gap-2 portal-section-grid">

                      <div class="flex flex-col gap-2 md:w-1/2">
                        <div class="flex flex-row gap-4 items-center portal-actions">
                          <span class="font-semibold">Parent Agency</span>
                          <button class="-mb-2" type="button" *ngIf="license.isSubunit" mat-button color="primary"
                            (click)="requestChange(0, sharedService.parent, sharedService.change)">
                            Set as Parent Agency
                          </button>
                        </div>

                        <mat-form-field>
                          <mat-label>Parent</mat-label>
                          <input matInput formControlName="parentAgency">
                          <mat-error *ngIf="licenseForm.get('parentAgency')?.hasError('parentNotFound')">
                            Cannot find parent agency
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex flex-col md:w-1/2">
                        <span class="font-semibold mt-2">Parent Info</span>

                        <div class="flex flex-row gap-4 items-center pt-2 portal-detail-row">
                          <span class="font-semibold md:w-1/4">License:</span>
                          <span>{{license.parentGuid}}</span>
                        </div>

                        <div class="flex flex-row gap-4 items-center portal-detail-row">
                          <span class="font-semibold md:w-1/4">City:</span>
                          <span>{{license.parentCity}}</span>
                        </div>

                        <div class="flex flex-row gap-4 items-center portal-detail-row">
                          <span class="font-semibold md:w-1/4">Distance:</span>
                          <span *ngIf="license.calculatedDistance! > 0"
                            [ngClass]="license.calculatedDistance! >= 60 || approved? 'text-green-500' : 'text-red-600'">
                            {{ license.calculatedDistance }} Miles</span>
                          <span *ngIf="license.calculatedDistance === 0" class="text-red-600">Add Physical
                            Address to Verify</span>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div [ngClass]="(licenseForm.get('entityName')?.invalid && !locked) ? 'pb-6' : ''" class="flex flex-col md:flex-row gap-2 portal-field-grid">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Agency Legal Name</span>
                      <mat-form-field class="portal-field-wide">
                        <mat-label>Legal Name</mat-label>
                        <input matInput formControlName="entityName">
                        <mat-error *ngIf="licenseForm.get('entityName')?.invalid && !locked">
                          You must include a name. The name cannot contain 'Home Health', and the name cannot
                          be the same as another agency.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Agency DBA (Doing Business As) Name (if applicable)</span>
                      <mat-form-field class="portal-field-wide">
                        <mat-label>DBA (Doing Business As) Name</mat-label>
                        <input matInput formControlName="agencyDBAName">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Agency Phone</span>
                      <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="agencyPhone" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('agencyPhone')?.hasError('required')">
                          Phone number required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('agencyPhone')?.hasError('pattern')">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Agency Email</span>
                      <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="agencyEmail">
                        <mat-error *ngIf="licenseForm.get('agencyEmail')?.hasError('required')">
                          Email is required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('agencyEmail')?.hasError('email')">
                          Not a valid email
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Agency Fax</span>
                      <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="agencyFax" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('agencyFax')?.invalid">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Emergency Contact Name</span>
                      <mat-form-field>
                        <mat-label>Emergency Name</mat-label>
                        <input matInput formControlName="emergencyContactName">
                        <mat-error *ngIf="licenseForm.get('emergencyContactName')?.invalid">
                          Emergency contact required
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Emergency Contact Phone</span>
                      <mat-form-field>
                        <mat-label>Emergency Phone</mat-label>
                        <input matInput formControlName="emergencyContactPhone" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('emergencyContactPhone')?.hasError('required')">
                          Emergency number required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('emergencyContactPhone')?.hasError('pattern')">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Emergency Contact Email</span>
                      <mat-form-field>
                        <mat-label>Emergency Email</mat-label>
                        <input matInput formControlName="emergencyContactEmail">
                        <mat-error *ngIf="licenseForm.get('emergencyContactEmail')?.hasError('required')">
                          Emergency email required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('emergencyContactEmail')?.hasError('pattern')">
                          Not a valid email
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Administrator Designee Name</span>
                      <mat-form-field>
                        <mat-label>Designee Name</mat-label>
                        <input matInput formControlName="adminDesigneeName">
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Admin Designee Title</span>
                      <mat-form-field>
                        <mat-label>Desginee Title</mat-label>
                        <input matInput formControlName="adminDesigneeTitle">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Qualified Individual/Entity Name</span>
                      <mat-form-field>
                        <mat-label>Entity Name</mat-label>
                        <input matInput formControlName="qualifiedEntityName">
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Qualified Individual/Entity Title</span>
                      <mat-form-field>
                        <mat-label>Entity Title</mat-label>
                        <input matInput formControlName="qualifiedEntityTitle">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row md:gap-4 items-center portal-section-grid">
                    <div class="flex flex-col gap-2 md:w-1/2" *ngIf="licenseForm.get('classificationLevel')?.value === 'Intermediate' ||
                                                                     licenseForm.get('classificationLevel')?.value  === 'Comprehensive'">
                      <div class="flex flex-row gap-4 items-center portal-actions">
                        <span class="font-semibold"><strong>Registered Nurse Name</strong></span>
                        <button class="-mb-2 ml-auto" type="button" *ngIf="approved" mat-button color="primary"
                          (click)="requestChange(0, sharedService.nurse, sharedService.change)">
                          Change Nurse
                        </button>
                      </div>
                      <mat-form-field>
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="registeredNurseName" (blur)="validateRegisteredNurse()">
                        <mat-error *ngIf="licenseForm.get('registeredNurseName')?.invalid">
                            Registered nurse name required
                          </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2">
                      <mat-checkbox class="-mt-3" formControlName="backgroundCheckCompleted" labelPosition="before">
                        <span class="font-semibold">Background Check Completed</span>
                      </mat-checkbox>
                      <mat-form-field>
                        <input placeholder="Background Check Date" formControlName="backgroundCheckDate" matInput [matDatepicker]="backgroundCheckDate"
                          [max]="sharedService.today" />
                        <mat-datepicker-toggle matSuffix [for]="backgroundCheckDate"></mat-datepicker-toggle>
                        <mat-datepicker #backgroundCheckDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Administrator Signaure</span>
                      <mat-form-field>
                        <mat-label>Signature</mat-label>
                        <input matInput formControlName="electronicSignature">
                        <mat-error *ngIf="licenseForm.get('electronicSignature')?.invalid">
                          A name is required
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Title</span>
                      <mat-form-field>
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="adminPrintTitle">
                        <mat-error *ngIf="licenseForm.get('adminPrintTitle')?.invalid">
                          A name is required
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Date Signed</span>
                      <mat-form-field>
                        <input placeholder="mm/dd/yyyy" formControlName="signedDate" matInput [matDatepicker]="signed" [max]="sharedService.today" />
                        <mat-datepicker-toggle matSuffix [for]="signed"></mat-datepicker-toggle>
                        <mat-datepicker #signed>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error *ngIf="licenseForm.get('signedDate')?.invalid">
                          Signature date required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col gap-6 portal-agency-hours" [ngClass]="editing? '' : 'md:flex-row'">
                  <div class="flex flex-col portal-full-panel" [ngClass]="editing? 'md:w-1/2' : 'md:w-1/3'">
                    <span class="font-semibold pb-2">Assigned To</span>
                    <mat-form-field *ngIf="authService.isAdmin">
                      <mat-select [(value)]="license.assignedToName" (selectionChange)="assignLicense($event, license.id)">
                        <mat-option>-- None --</mat-option>
                        <mat-option *ngFor="let staff of staff" value={{staff.name}}>{{staff.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <span *ngIf="!authService.isAdmin">{{ license.assignedToName }}</span>
                  </div>
                </div>
              </div>

              <!-- Physical Location / Agency Documents-->
              <div class="flex flex-col md:w-1/2">
                <div class="flex flex-col gap-2 pb-4">

                  <div class="flex flex-col md:flex-row md:gap-4" *ngIf="!editing">
                    <div class="flex flex-col gap-2">
                      <span class="font-semibold">Physically Located Within</span>
                      <span>{{ license.agencyPhysicalLocation }}</span>
                    </div>

                    <div class="flex flex-col gap-2" *ngIf="license.agencyPhysicalLocation === 'Other Licensed Facility or Agency Type'">
                      <span class="font-semibold">Other Licensed Facility or Agency Type</span>
                      <span>{{ license.otherLocation }}</span>
                    </div>
                  </div>

                  <div class="flex flex-row gap-4 items-center portal-actions">
                    <button *ngIf="approved && editing" type="button" mat-button color="primary" class="ml-auto"
                      (click)="requestChange(0, sharedService.address, sharedService.change)">Change Physical Address</button>
                  </div>

                  <address [entityId]="license.id"
                           [entityType]="sharedService.inHomeCareLicense"
                           [limitEntries]="true"
                           [limitTo]="2"
                           [statuses]="license.statuses"
                           [isEditable]="editing"
                           (addressesLoaded)="addressesLoadedEvent($event)">
                  </address>

                  <div class="flex flex-col gap-2" *ngIf="editing">
                    <mat-form-field appearance="fill">
                      <input matInput formControlName="agencyPhysicalLocation" style="display: none;">
                      <mat-radio-group class="flex flex-wrap" aria-labelledby="agency-physical-location"
                        formControlName="agencyPhysicalLocation">
                        <mat-radio-button value="Commercial Business Building">
                          Commercial Business Building
                        </mat-radio-button>
                        <mat-radio-button value="Private Home Residence">
                          Private Home/Residence
                        </mat-radio-button>
                        <mat-radio-button value="Independent Living Retirement Facility or Community">
                          Independent Living Retirement Facility or Community
                        </mat-radio-button>
                        <mat-radio-button value="Registered Continuing Care Retirement Community">
                          Registered Continuing Care Retirement Community
                        </mat-radio-button>
                        <mat-radio-button value="Other Licensed Facility or Agency Type">
                          Other Licensed Facility or Agency Type
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="licenseForm.get('agencyPhysicalLocation')?.hasError('required')">
                        You must select a classification level
                      </mat-error>
                    </mat-form-field>

                    <div class="flex flex-col gap-2 md:w-1/2 portal-full-panel" *ngIf="licenseForm.get('agencyPhysicalLocation')?.value === 'other'">
                      <span class="font-semibold">Other Licensed Facility or Agency Type</span>
                      <mat-form-field>
                        <mat-label>Location Type</mat-label>
                        <input matInput formControlName="otherLocation" (blur)="validatePhysicalLocation()">
                        <mat-error *ngIf="licenseForm.get('otherLocation')?.invalid">
                          Location required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>



                <app-office-hours class="block w-full mt-6"
                    [entityId]="license.id"
                    [entityType]="sharedService.inHomeCareLicense"
                    [editing]="editing">
                  </app-office-hours>
              </div>
            </div>
            <div class="w-full mt-6">
              <span class="font-semibold">Agency Documents</span>
              <document [entityId]="license.id"
                        [entityType]="sharedService.inHomeCareLicense"
                        [statuses]="license.statuses"
                        [types]="inHomeCareTypes"
                        [editable]="editing">
              </document>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>

    <!-- Owners and Branches-->
    <div class="flex flex-col md:flex-row gap-4 py-4 portal-section-grid portal-ownership-layout">
      <!-- Entity Owners -->
      <mat-card class="md:w-1/2">
        <mat-card-content>
          <mat-card>
            <mat-card-content>
              <entity-owner *ngIf="!license.isSubunit || subunitLoaded"
                            [entityId]="license.id"
                            [entityType]="sharedService.inHomeCareLicense"
                            [entityGuid]="license.licenseId"
                            [parentId]="parentId"
                            [statuses]="license.statuses"
                            [isSubunit]="license.isSubunit!"
                            [isEditable]="editing">
              </entity-owner>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>

      <!-- Branch Operations -->
      <mat-card class="md:w-1/2">
        <mat-card-content>
          <mat-card>
            <mat-card-content>
              <branch-operation *ngIf="addressesLoaded"
                                [entityId]="license.id"
                                [entityType]="sharedService.inHomeCareLicense"
                                [entityGuid]="license.licenseId"
                                [agencyAddresses]="addresses?.addresses || []"
                                [statuses]="license.statuses"
                                [isEditable]="editing"
                                [isRenewal]="isRenewal"
                                [isChange]="false">
              </branch-operation>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Administrator Application -->
    <mat-card>
      <mat-card-content>
        <mat-card>
          <mat-card-content>
            <administrator-application [entityId]="license.id"
                                       [entityType]="sharedService.inHomeCareLicense"
                                       [entityGuid]="license.licenseId"
                                       [statuses]="license.statuses"
                                       [isEditable]="editing">
            </administrator-application>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>

    <!-- Payments -->
    <div class="mt-4">
      <app-manage-payments [entityId]="license.id.toString()"
                           [entityType]="sharedService.inHomeCareLicense"
                           [classification]="license.classificationLevel!"
                           [allowMultiplePayments]="true"
                           [allowDelete]="false"
                           [editingPayment]="true"
                           (notifyParent)="paymentsLoadedEvent(true)"></app-manage-payments>
    </div>

    <!-- Notes -->
    <div class="mt-4">
      <notes [entityId]="license.id"
             [entityType]="sharedService.inHomeCareLicense">
      </notes>
    </div>

    <!-- Change Requests -->
    <div class="flex flex-col gap-2 mt-4">
      <span class="text-lg font-semibold">Change Requests / History</span>
      <in-home-care-change [licenseId]="license.id"
                           (changeApproved)="changeApproved($event)">
      </in-home-care-change>

      <app-entity-task [entityId]="license.id"
                       [entityType]="sharedService.inHomeCareLicense">
      </app-entity-task>

    </div>

    <!-- Communication Logs-->
    <div class="flex flex-col gap-2 mt-4">
      <span class="text-lg font-semibold">Communication Logs</span>
      <communication-logs [entityId]="license.id"
                         [entityType]="sharedService.inHomeCareLicense">
      </communication-logs>
    </div>

    <!-- Complaints -->
    <div class="flex flex-col gap-2 pt-4">
      <span class="text-lg font-semibold">Complaints</span>
      <app-complaint [entityId]="license.id"
                     [licenseId]="license.licenseId"
                     [entityType]="sharedService.inHomeCareLicense">
      </app-complaint>
    </div>

    <!-- Validation Errors Display -->
    <mat-card *ngIf="validationErrors.length > 0 && license.id > 0" class="mt-4 border-l-4 border-red-500">
      <mat-card-header>
        <mat-card-title class="text-red-600">
          <mat-icon class="mr-2">error</mat-icon>
          Validation Errors
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-col gap-2">
          <div *ngFor="let error of validationErrors" class="text-red-600 pl-4">
            <mat-icon class="text-sm mr-2">warning</mat-icon>
            {{error}}
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Staff Management -->
    <mat-card class="mt-4">
      <mat-card-content>
        <mat-card>
          <mat-card-content>
            <div class="flex flex-col md:flex-row gap-6 portal-section-grid">

              <div class="flex flex-col gap-2 md:w-2/3 portal-approvers">
                <div class="portal-approver-column">
                  <div class="flex flex-col gap-2 md:w-1/3">
                    <span class="font-semibold">Primary Approver Name</span>
                    <mat-form-field>
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="primaryApproverName">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/12">
                    <span class="font-semibold">Initials</span>
                    <mat-form-field>
                      <mat-label>Initials</mat-label>
                      <input matInput formControlName="primaryInitials">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2">
                    <label id="primary-approved" class="font-semibold">Approved</label>
                    <mat-radio-group aria-labelledby="Primary Approved" formControlName="primaryApproved">
                      <mat-radio-button [value]="true">Yes</mat-radio-button>
                      <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/6">
                    <span class="font-semibold">Approval Date</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="primaryApprovalDate" matInput [matDatepicker]="primaryApproval"
                        [max]="sharedService.today" />
                      <mat-datepicker-toggle matSuffix [for]="primaryApproval"></mat-datepicker-toggle>
                      <mat-datepicker #primaryApproval>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <div class="portal-approver-column">
                  <div class="flex flex-col gap-2 md:w-1/3">
                    <span class="font-semibold">Secondary Approver Name</span>
                    <mat-form-field>
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="secondaryApproverName">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/12">
                    <span class="font-semibold">Initials</span>
                    <mat-form-field>
                      <mat-label>Initials</mat-label>
                      <input matInput formControlName="secondaryInitials">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2">
                    <label id="secondary-approved" class="font-semibold">Approved</label>
                    <mat-radio-group aria-labelledby="Secondary Approved" formControlName="secondaryApproved">
                      <mat-radio-button [value]="true">Yes</mat-radio-button>
                      <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/6">
                    <span class="font-semibold">Approval Date</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="secondaryApprovalDate" matInput [matDatepicker]="secondaryApproval"
                        [max]="sharedService.today" />
                      <mat-datepicker-toggle matSuffix [for]="secondaryApproval"></mat-datepicker-toggle>
                      <mat-datepicker #secondaryApproval>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <div class="portal-approver-notes">
                  <mat-form-field class="md:w-1/2">
                    <mat-label>Reason</mat-label>
                    <textarea matInput rows="3" formControlName="reason"></textarea>
                  </mat-form-field>

                  <mat-checkbox *ngIf="!isRenewal" formControlName="initialSurveyComplete" labelPosition="before" class="-mt-4">
                    <span>Initial Survey Complete</span>
                  </mat-checkbox>
                </div>
              </div>

              <div class="flex flex-col gap-4 md:w-1/3">
                <span class="font-semibold">License Status</span>

                <div class="flex flex-col md:flex-row gap-2">
                  <span class="font-semibold">Current:</span>
                  <div class="flex flex-col">
                    <span *ngFor="let status of license.statuses">{{status.label}}</span>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2">
                  <span class="font-semibold">Initial Date:</span>
                  <div class="flex flex-col">
                    <span *ngFor="let status of license.statuses">{{license.initialLicensure}}</span>
                  </div>
                </div>

                <div class="flex flex-col gap-2 md:w-1/2 portal-full-panel" *ngIf="canEditApprovedDate">
                  <span class="font-semibold">Issued Date</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="approvedDate" matInput [matDatepicker]="issuedDatePicker" />
                    <mat-datepicker-toggle matSuffix [for]="issuedDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #issuedDatePicker>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-1/2 portal-full-panel">
                  <span class="font-semibold">Expiration Date</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="expirationDate" matInput [matDatepicker]="expirationDatePicker" />
                    <mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #expirationDatePicker>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2" *ngIf="paymentsLoaded">
                  <span class="font-semibold">Select a Status</span>
                  <mat-form-field appearance="fill" class="md:w-1/2 portal-full-panel">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                      <mat-option *ngFor="let status of sharedService.statusList | filterApproved" [value]="status.id">{{status.label}}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </div>

                <div *ngIf="canApprove">
                  <button type="button" mat-raised-button color="primary" (click)="approveLicense()">
                    Approve License
                  </button>
                </div>

                <div class="flex flex-row mt-auto gap-4 portal-actions">
                  <button class="ml-auto" type="button" mat-raised-button color="primary" (click)="saveLicense()">Save License</button>
                  <button type="button" mat-raised-button color="primary" (click)="closeLicense()">Close</button>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </form>
</div>
